import { useNavigate } from 'react-router-dom';
import { useWaWorkplaceStore } from 'src/api/wa/store/WaWorkplaceStore';
import PropertiesHeader from '../../common/propertiesHeader/PropertiesHeader';
import { ButtonProps } from '../../common/button/Button';
import LinkButton from '../../common/button/LinkButton';
import { WaScreensMap } from '../../router/WardsScreenMap';
import { WA_Screen } from '../../router/WardsScreens';
import { wardsNavigate } from '../../router/WardsScreenRegistration';
import useWaUsersService from 'src/api/wa/service/WaUsersService';
import { getDetailStatusTranslationKey } from 'src/api/wa/store/models/workplace/OperationStatus';
import { useEffect, useState } from 'react';
import { Workplace } from 'src/api/wa/store/models/workplace';
import { FormRow } from '../../common/form/FormRow';
import { useTranslation } from 'react-i18next';
import { useWaDisasterStore } from 'src/api/wa/store/WaRegionAndDisasterStore';

const WorkplaceListItem: React.FC<{
  site: Workplace;
  onDetailsClick: (site: Workplace) => void;
}> = ({ site, onDetailsClick }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2 border-t border-gray-300 px-4 py-3">
      <div className="w-full space-y-3">
        <FormRow title={t('wards.common.customerNumber')} layout="vertical" className="text-sm">
          <LinkButton title={site.customerId} onClick={() => onDetailsClick(site)} />
        </FormRow>
        <FormRow title={t('wards.common.status')} layout="vertical" className="text-sm">
          <span>
            {site.details?.statusId ? t(getDetailStatusTranslationKey(site.details?.statusId)) : ''}
          </span>
        </FormRow>
        <FormRow title={t('wards.sites.buildingName')} layout="vertical" className="text-sm">
          <span>
            {site.emergencyClass ? '★' : ''} {site.name}
          </span>
        </FormRow>
        <FormRow title={t('wards.siteDetails.comment')} layout="vertical" className="text-sm">
          <span>
            {site.details?.comment ? t('wards.common.withComment') : t('wards.common.noComment')}
          </span>
        </FormRow>
      </div>
    </div>
  );
};

function S4_1_AdressedPropertiesList() {
  const { setSelectedWorkplace } = useWaWorkplaceStore();
  const { fetchCurrentUserReservations } = useWaUsersService();
  const { selectedDisaster } = useWaDisasterStore();
  const [workplaces, setWorkplaces] = useState<Workplace[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttons: ButtonProps[] = [
    {
      key: 'menu',
      title: t('wards.common.menu'),
      onClick: () => {
        wardsNavigate(navigate, WaScreensMap[WA_Screen.RecoverySupportMenu].path);
      },
    },
  ];

  const handleDetailsClick = (site: Workplace) => {
    setSelectedWorkplace(site);
    wardsNavigate(navigate, WaScreensMap[WA_Screen.WorkplaceDetails].path);
  };

  useEffect(() => {
    if (selectedDisaster) {
      (async () => {
        const workplaces = await fetchCurrentUserReservations(selectedDisaster?.id);
        setWorkplaces(workplaces);
      })();
    }
  }, [selectedDisaster, fetchCurrentUserReservations]);

  // Limit to max 100 records as per specification
  const resolvedWorkplaces = (workplaces ?? []).slice(0, 100);

  return (
    <div className="bg-gray-100 pb-20">
      <PropertiesHeader title={t('wards.supportMenu.addressedPropertiesList')} buttons={buttons} />
      {resolvedWorkplaces.length > 0 ? (
        <div>
          {resolvedWorkplaces.map((site) => (
            <WorkplaceListItem
              key={site.customerId}
              site={site}
              onDetailsClick={handleDetailsClick}
            />
          ))}
        </div>
      ) : (
        <div className="px-4">{t('wards.sites.noReservedProperties')}</div>
      )}
      <PropertiesHeader title="" buttons={buttons} />
    </div>
  );
}

export default S4_1_AdressedPropertiesList;
